import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'cookieConsentAccepted';

// Отдельно от ConsentGate (согласие на обработку ПДн при регистрации) — это уведомление
// об использовании cookie, которое должны видеть ВСЕ посетители сайта, включая
// незарегистрированных, на главном экране и везде ещё до входа в аккаунт.
export default function CookieConsentBanner() {
    const { t } = useTranslation(['consent', 'common']);
    const [dismissed, setDismissed] = useState(() => {
        try {
            return !!localStorage.getItem(STORAGE_KEY);
        } catch {
            return false;
        }
    });

    if (dismissed) return null;

    function accept() {
        try {
            localStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch {
            // приватный режим браузера — просто скрываем до следующей загрузки страницы
        }
        setDismissed(true);
    }

    return (
        <div style={{
            position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 4000,
            background: '#1A1A1A', color: '#f1f5f9',
            padding: '14px 16px', display: 'flex', alignItems: 'center',
            justifyContent: 'center', gap: 16, flexWrap: 'wrap',
            boxShadow: '0 -4px 20px rgba(0,0,0,0.25)', fontSize: 13,
        }}>
            <span style={{ maxWidth: 640, lineHeight: 1.5 }}>
                🍪 {t('consent:cookieNoticeText')}{' '}
                <a href="/cookies" target="_blank" rel="noopener noreferrer" style={{ color: '#fca5a5', fontWeight: 700 }}>
                    {t('consent:cookieNoticeLink')}
                </a>
            </span>
            <button
                type="button"
                onClick={accept}
                style={{
                    background: '#EB3333', color: '#fff', border: 'none',
                    borderRadius: 8, padding: '10px 20px', fontWeight: 700,
                    fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap',
                }}
            >
                {t('consent:cookieNoticeAccept')}
            </button>
        </div>
    );
}
